(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["creatures-decouverte"] && !Shopify.designMode) return;
  try {
    
/* Autoplay is managed on visibility, so offscreen clips do not all start loading. */
if (!customElements.get('cc-creature-video')) {
  customElements.define('cc-creature-video', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const video = this.querySelector('video');
      const button = this.querySelector('.cc-play');
      const error = this.querySelector('.cc-video-error');
      if (!video || !button) return;
      const abort = new AbortController();
      const on = (target, type, fn) => target.addEventListener(type, fn, { signal: abort.signal });
      let visible = false;
      let manuallyPaused = false;
      let suspended = false;
      let resume = false;
      let pending = false;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const canAuto = () => this.dataset.autoplay === 'true' &&
        !reducedMotion.matches && !navigator.connection?.saveData;
      const sync = () => { button.hidden = !video.paused && !video.ended; };
      const play = async (manual = false) => {
        if (pending) return;
        pending = true;
        error.hidden = true;
        if (manual) manuallyPaused = false;
        else video.muted = true;
        try {
          await video.play();
          if (suspended) video.pause();
        } catch (e) {
          if (manual && e.name !== 'AbortError') error.hidden = false;
        } finally {
          pending = false;
          sync();
        }
      };
      const update = () => {
        const active = visible && !document.hidden;
        if (!active) {
          if (!suspended) {
            resume = !video.paused || pending;
            suspended = true;
            video.pause();
          }
          return;
        }
        suspended = false;
        if (resume || (canAuto() && !manuallyPaused)) {
          resume = false;
          play();
        }
      };
      video.muted = true;
      video.playsInline = true;
      on(button, 'click', () => play(true));
      on(video, 'playing', () => {
        error.hidden = true;
        if (suspended) video.pause();
        sync();
      });
      on(video, 'pause', () => {
        if (!suspended) manuallyPaused = true;
        sync();
      });
      on(video, 'ended', () => { manuallyPaused = true; sync(); });
      on(video, 'error', () => { error.hidden = false; sync(); });
      on(document, 'visibilitychange', update);
      let observer;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(entries => {
          visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.25;
          update();
        }, { threshold: [0, 0.25] });
        observer.observe(this);
      } else {
        visible = true;
        update();
      }
      sync();
      this.cleanup = () => {
        suspended = true;
        abort.abort();
        observer?.disconnect();
        video.pause();
      };
    }
    disconnectedCallback() {
      this.cleanup?.();
      this.cleanup = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      //this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    /*
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    } */
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
